import React from 'react';
import imagen from '../imagen.png'

const Header = () => {
    return ( 
        <header className="bg-alert">
            <h1>Toma Conmigo</h1>
            <div className="text-center">
                <img src={imagen} width="60" />
            </div>
        </header>

     );
}
 
export default Header;